import * as React from 'react';
//FluentUI
import { 
  Sticky,
  ScrollablePane,
  SearchBox,
  CommandBar,
  MessageBar,
  MessageBarButton,
  MessageBarType,
  DetailsRow } from '@fluentui/react';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
} from 'office-ui-fabric-react/lib/DetailsList';
//Theme
import style from './style';
import { withStyles } from '@material-ui/core';

import { eventyTypes } from '../../../../../../stores';
//Components
import {AddTender} from '../../';
import {Pagination} from '../../../../../../components';
import {DeleteProgress,InfoCallout} from './components';
//Models
import data from './data';
import {apiRequest} from './apiRequest';

const WarningPanel = (p) => (
  <MessageBar
    messageBarType={MessageBarType.warning}
    isMultiline={false}
    onDismiss={p.resetChoice}
    dismissButtonAriaLabel="Close"
    actions={
      <div>
        <MessageBarButton onClick={p.onYes}>Igen</MessageBarButton>
        <MessageBarButton onClick={p.onNo}>Nem</MessageBarButton>
      </div>
    }
  >
   Biztosan törölni szeretnéd ?
  </MessageBar>
);



export class TenderList extends React.Component {

  constructor(props) {
    super(props);


    this.state = {
      //table rows
      items: [],
      columns: data.setColumns(this,'default'),
      isCompactMode: false,
      //filter
      filteredItems:[],
      isFiltered:false,
      //interactions
      addNew:false,
      deleteRequest:null,
      requestResponse:null,
      deleteIsProgress:false,
      //pagination
      first:0,
      last:0,
      //request
      loading:true,
      //commands
      commandItems: data.setCommandItems(this),
      commandFarItems:data.setFarCommandItems(this),
      info:false
    };

    this._onItemInvoked  = this._onItemInvoked.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.refresh = this.refresh.bind(this);
    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handleDeleteRequest = this.handleDeleteRequest.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount(){
    apiRequest.getTenders(this);
  }

  componentDidUpdate(prevProps,prevState){
    const {deleteRequest} = this.state;
    if(deleteRequest!=prevState.deleteRequest){
      if(deleteRequest!==null){
        this.setState({
          columns: data.setColumns(this,'delete')
        });
      }else{
        this.setState({
          columns: data.setColumns(this,'default'),
          deleteIsProgress:false
        });
      }
    }
  }

  //*Helper methods*//
  refresh(){
    this.setState({
      loading:true
    });
    apiRequest.getTenders(this);
  }

  setMessageBarType(type){
    switch(type){
      case 'success':
        return MessageBarType.success
      case 'warning':
        return MessageBarType.warning
      case 'error':
        return MessageBarType.error
      default: 
        return MessageBarType.error
    }
  }

  handleOpenInfo = () =>{
    this.setState({
      info:true
    })
  }

  handleCloseInfo = () =>{
    this.setState({
      info:false
    })
  }

  handleResponsePanel=()=>{
    this.setState({
      requestResponse:null
    })
  }
  //**//

  //*Delete actions*//

  handleDeleteRequest(item){
    this.setState({
      deleteRequest:item,
      requestResponse:null,
    });
  }

  handleDelete(){
    const {deleteRequest} = this.state;

    //Fill model
    const model = {id:deleteRequest.id};
    //Call api
    apiRequest.deleteTender(this,model);
  }

  handleCancelDelete(){
    this.setState({
      deleteRequest:null
    })
  }
  //**//

  //*Handle modals*//
  handleOpen(){
    this.setState({
      addNew:true
    });
  }

  handleClose(){
    this.setState({
      addNew:false
    });
  }
  //**//

  //*Select clicled row*//
  handleClick(item){

    this.props.onSelect(item);
    if(item.tenderChanges==eventyTypes.CREATE){
      apiRequest.noticeChanges(this,item);
    }
  
  }
  //**//

  render() {
    const { columns,info, isCompactMode,deleteRequest,deleteIsProgress,requestResponse, items,commandItems,first,last,commandFarItems,addNew,filteredItems,isFiltered,loading  } = this.state;
    const {classes,partners} = this.props;
    return (
      <div>
          <CommandBar
            items={commandItems}
            farItems={commandFarItems}
          />
        {addNew===true && <AddTender partners={partners} onRefresh={this.refresh} open={addNew} hideModal={this.handleClose}/>}
        {info===true && <InfoCallout  onClose={()=>this.handleCloseInfo()} buttonId={`bt-info`} />}
        {deleteRequest!==null && 
          <WarningPanel 
            onYes={()=>this.handleDelete(deleteRequest)} 
            onNo={this.handleCancelDelete}
          />
        }
        <DeleteProgress onClose={this.closeProgressModal} open={deleteIsProgress}/>
        {requestResponse!==null &&
          <MessageBar
            messageBarType={this.setMessageBarType(requestResponse.type)}
            isMultiline={false}
            actions={
              <div>
                <MessageBarButton onClick={this.handleResponsePanel}>Ok</MessageBarButton>
              </div>
             }
          >
            {requestResponse.message}
          </MessageBar>
        }      
        <div className={classes.table}>
          <div style={style.fluentUI.controlWrapper}>
            <SearchBox style={style.fluentUI.search} placeholder="Keresés..." onChange={this._onChangeText} />
          </div>
          <div style={style.fluentUI.tableWrapper}>
          <ScrollablePane>
            <DetailsList
              items={isFiltered ? filteredItems.slice(first,last) : items.slice(first,last)}
              compact={isCompactMode}
              columns={columns}
              selectionMode={SelectionMode.none}
              getKey={this._getKey}
              setKey="none"
              layoutMode={DetailsListLayoutMode.justified}
              onRenderDetailsHeader={
                (detailsHeaderProps, defaultRender) => (
                  <Sticky>
                    {defaultRender(detailsHeaderProps)}
                  </Sticky>
                ) }
              isHeaderVisible={true}
              onItemInvoked={this._onItemInvoked}
              onRenderRow={this.onRenderColumnListRow}
            />
            </ScrollablePane>
          </div>
          <Pagination loading={loading} parent={this} length={isFiltered ? filteredItems.length : items.length}/>
        </div>
      </div>
    );
  }

  //*To render table rows*//

  onRenderColumnListRow= (props) => {
    const {deleteRequest} = this.state
    const customStyles = {};
    if (props) {
      if(deleteRequest!==null && deleteRequest!==undefined && deleteRequest.id===props.item.id){
        customStyles.root = style.fluentUI.highlightRow;
        return <DetailsRow {...props} styles={customStyles} />;
      }else if(props.item.isClosed===true && props.item.hasWinner===false){
        customStyles.root = style.fluentUI.closedRow;
        return <DetailsRow {...props} styles={customStyles}/>;
      }else if(props.item.isClosed===true && props.item.hasWinner===true){
        customStyles.root = style.fluentUI.hasWinnerRow;
        return <DetailsRow {...props} styles={customStyles}/>;
      }
      else{
        customStyles.root = style.fluentUI.tableRow;
        return <DetailsRow {...props} styles={customStyles}/>;
      }
    }
    return null;
  };

   _getKey(item, index) {
    return item.key;
  }

   _onChangeCompactMode = (ev, checked) => {
    this.setState({ isCompactMode: checked });
  };

   _onChangeText = (ev, text) => {
     if(text!=='' && text!==null && text!==undefined){
       this.setState({
         isFiltered:true
       });
     }else{
      this.setState({
        isFiltered:true
      });
     }
     const {items} = this.state;
      this.setState({
        filteredItems: text ? items.filter(i => i.name.toLowerCase().indexOf(text.toLowerCase()) > -1) : items,
        requestResponse:null
      });
  };

   _onItemInvoked(item) {
     this.handleClick(item);
  }


   _onColumnClick = (ev, column) => {
    const { columns, items } = this.state;
    const newColumns= columns.slice();
    const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
    newColumns.forEach((newCol) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
        this.setState({
          announcedMessage: `${currColumn.name} is sorted ${
            currColumn.isSortedDescending ? 'descending' : 'ascending'
          }`,
        });
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });
    const newItems = _copyAndSort(items, currColumn.fieldName, currColumn.isSortedDescending);
    this.setState({
      columns: newColumns,
      items: newItems,
    });
  };
}

function _copyAndSort(items, columnKey, isSortedDescending) {
  const key = columnKey;;
  return items.slice(0).sort((a, b) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}

//**//



export default withStyles(style.materialUI)(TenderList);